<template>
  <page>
    <div :load="doInit">
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-file-document</v-icon> Report Type</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-autocomplete
                        v-model="reportForm.type"
                        :label="labels.type"
                        :items="reportTypeList"
                        item-text="label"
                        item-value="value"
                        :error-messages="errors.collect('reportForm.type')"
                        data-vv-name="reportForm.type"
                        :data-vv-as="labels.type"
                        v-validate="'required'"
                        @change="onChange()"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-calendar</v-icon> Date Ranges</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs6 md6>
                      <cal-picker
                        v-model="reportForm.entDateFrom"
                        :label="labels.entDateFrom"
                        v-validate="fromDateValidation(reportForm.entDateFrom, reportForm.entDateTo)"
                        :data-vv-as="labels.entDateFrom"
                        data-vv-name="entDateFrom"
                        :error-messages="errors.collect('entDateFrom')"
                        :max="this.today"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6 md6>
                      <cal-picker
                        v-model="reportForm.entDateTo"
                        :label="labels.entDateTo"
                        v-validate="toDateValidation(reportForm.entDateFrom, reportForm.entDateTo)"
                        :data-vv-as="labels.entDateTo"
                        data-vv-name="entDateTo"
                        :error-messages="errors.collect('entDateTo')"
                        :max="this.today"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6 md6>
                      <cal-picker
                        v-model="reportForm.tranDateFrom"
                        :label="labels.tranDateFrom"
                        v-validate="fromDateValidation(reportForm.tranDateFrom, reportForm.tranDateTo)"
                        :data-vv-as="labels.tranDateFrom"
                        data-vv-name="tranDateFrom"
                        :error-messages="errors.collect('tranDateFrom')"
                        :max="this.today"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6 md6>
                      <cal-picker
                        v-model="reportForm.tranDateTo"
                        :label="labels.tranDateTo"
                        v-validate="toDateValidation(reportForm.tranDateFrom, reportForm.tranDateTo)"
                        :data-vv-as="labels.tranDateTo"
                        data-vv-name="tranDateTo"
                        :error-messages="errors.collect('tranDateTo')"
                        :max="this.today"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6 md6>
                      <cal-picker
                        v-model="reportForm.commDateFrom"
                        :label="labels.commDateFrom"
                        v-validate="fromDateValidation(reportForm.commDateFrom, reportForm.commDateTo)"
                        :data-vv-as="labels.commDateFrom"
                        data-vv-name="commDateFrom"
                        :error-messages="errors.collect('commDateFrom')"
                        :max="this.reportForm.type == 1 && this.today"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6 md6>
                      <cal-picker
                        v-model="reportForm.commDateTo"
                        :label="labels.commDateTo"
                        v-validate="toDateValidation(reportForm.commDateFrom, reportForm.commDateTo)"
                        :data-vv-as="labels.commDateTo"
                        data-vv-name="commDateTo"
                        :error-messages="errors.collect('commDateTo')"
                        :max="this.reportForm.type == 1 && this.today"
                      ></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel3" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        :loading="loading"
                        v-model="reportForm.tranTypes"
                        :label="labels.tranTypes"
                        :error-messages="errors.collect('tranTypes')"
                        data-vv-name="tranTypes"
                        :data-vv-as="labels.tranTypes"
                        append-icon="mdi-magnify"
                        @click:append="showTranTypeHelpList = true"
                        :disabled="disabled"
                      />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        :loading="loading"
                        v-model="reportForm.entUsrId"
                        :label="labels.entUsrId"
                        :error-messages="errors.collect('entUsrId')"
                        data-vv-name="entUsrId"
                        :data-vv-as="labels.entUsrId"
                        append-icon="mdi-magnify"
                        @click:append="showUserList = true"
                        clearable
                      />
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.newPagePerUsr" v-model="reportForm.newPagePerUsr" />
                    </v-flex>
                    <v-flex xs6>
                      <!-- <v-text-field :label="labels.agency" v-model="reportForm.agency" /> -->
                      <v-text-field
                        :loading="loading"
                        v-model="reportForm.agency"
                        :label="labels.agency"
                        :error-messages="errors.collect('agency')"
                        data-vv-name="agency"
                        :data-vv-as="labels.agency"
                        append-icon="mdi-magnify"
                        @click:append="showAgencyHelpList = true"
                        clearable
                      />
                    </v-flex>
                    <v-flex xs6> </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        :loading="loading"
                        v-model="reportForm.branches"
                        :label="labels.branches"
                        :error-messages="errors.collect('branches')"
                        data-vv-name="branches"
                        :data-vv-as="labels.branches"
                        append-icon="mdi-magnify"
                        @click:append="showBranchHelpList = true"
                      />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        :loading="loading"
                        v-model="reportForm.polTypes"
                        :label="labels.polTypes"
                        :error-messages="errors.collect('polTypes')"
                        data-vv-name="polTypes"
                        :data-vv-as="labels.polTypes"
                        append-icon="mdi-magnify"
                        @click:append="showPolTypeHelpList = true"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-form>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                <v-icon left dark>mdi-file-export</v-icon>
                {{ labels.export }}
              </v-btn>
              <v-btn-toggle dense mandatory v-model="reportForm.format">
                <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                  <span>{{ format.label }}</span>
                  <v-icon :color="format.color">{{ format.icon }}</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex sm6 xs12>
              <v-checkbox
                dense
                v-model="reportForm.printRptRunTime"
                :label="labels.printRptRunTime"
                data-vv-name="printRptRunTime"
                :data-vv-as="labels.printRptRunTime"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="reportForm.branches" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list :pt="reportForm.polTypes" @close="doClose" @doAssign="doAssignPolType($event)" />
    </v-dialog>
    <v-dialog v-model="showTranTypeHelpList" width="900px" persistent>
      <tran-type-help-list-new
        :param="reportForm.tranTypes"
        :boolRefresh="showTranTypeHelpList"
        @close="doClose"
        @doAssign="doAssign('tranTypes', $event)"
      />
    </v-dialog>
    <v-dialog v-model="showAgencyHelpList" width="1280px">
      <agency-help-list @close="showAgencyHelpList = false" @assign-agency="assignAgency"></agency-help-list>
    </v-dialog>
    <v-dialog v-model="showUserList" width="1280px">
      <user-help-list @close="showUserList = false" @assign-user="assignUser"></user-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import TranTypeHelpListNew from '@/components/reports/underwriting/helplist/TranTypeHelpListNew'
import AgencyHelpList from '@/components/reports/underwriting/helplist/AgencyHelpList'
import UserHelpList from '@/components/reports/underwriting/helplist/UserHelpList'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        type: 'Report Type',
        entDateFrom: 'Entry Date From',
        entDateTo: 'Entry Date To',
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'Transaction Date To',
        commDateFrom: 'Commencement Date From',
        commDateTo: 'Commencement Date To',
        tranTypes: 'Transaction Types',
        entUsrId: 'Entry User ID',
        newPagePerUsr: 'New Page for each User ID',
        agency: 'Agency',
        branches: 'Branches',
        polTypes: 'Policy Types',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print report runtime parameters'
      },
      reportForm: {
        type: 1,
        entDateFrom: undefined,
        entDateTo: undefined,
        tranDateFrom: undefined,
        tranDateTo: undefined,
        commDateFrom: undefined,
        commDateTo: undefined,
        tranTypes: 'All',
        entUsrId: undefined,
        newPagePerUsr: false,
        agency: undefined,
        branches: 'All',
        polTypes: 'All',
        format: undefined,
        printRptRunTime: false
      },
      reportTypeList: [
        { value: 1, label: 'Policies Not Released' },
        { value: 2, label: 'Entered Renewal Policies Not Released' }
        // { value: 1, label: 'Batch Renewal Policies Not Released' }, // remarked OS-946 09Dec2021
        // { value: 2, label: 'Entered Renewal Policies Not Released' }, // remarked OS-946 09Dec2021
        // { value: 3, label: 'Policies Not Released' } // remarked OS-946 09Dec2021
      ],
      // HelpList
      showBranchHelpList: false,
      showPolTypeHelpList: false,
      showTranTypeHelpList: false,
      showAgencyHelpList: false,
      showUserList: false,
      // Other
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      supportedFormat: [],
      loading: false,
      billAcctNoList: [],
      panel1: [0],
      panel2: [0],
      panel3: [0],
      disabled: false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initRenPolUnrel
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doAssignBranch(Obj) {
      this.reportForm.branches = Obj.finalSelectedItems.toString()
    },
    doAssignPolType(data) {
      this.reportForm.polTypes = data.finalSelectedItems.toString()
    },
    async doAssign(field, Obj) {
      switch (field) {
        case 'tranTypes':
          this.reportForm.tranTypes = Obj.finalSelectedItems.toString()
          break
      }
    },
    assignAgency(inter) {
      this.reportForm.agency = inter.inter
      this.showAgencyHelpList = false
    },
    assignUser(user) {
      this.reportForm.entUsrId = user.usrId
      this.showUserList = false
    },
    doClose() {
      this.showBranchHelpList = false
      this.showPolTypeHelpList = false
      this.showTranTypeHelpList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.allDateValidation()
          // this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    onChange() {
      this.disabled = false
      this.reportForm.tranTypes = 'All'
      if (this.reportForm.type === 2) {
        this.reportForm.tranTypes = 'R'
        this.disabled = true
      }
    },
    fromDateValidation(fromDate1, toDate1) {
      if (fromDate1 !== undefined && toDate1 !== undefined) {
        return 'valDateRangeFrom:' + toDate1
      } else if (fromDate1 === undefined && toDate1 !== undefined) {
        return 'required'
      }
      return ''
    },
    toDateValidation(fromDate1, toDate1) {
      if (fromDate1 !== undefined && toDate1 !== undefined) {
        return 'valDateRangeTo:' + fromDate1
      } else if (fromDate1 !== undefined && toDate1 === undefined) {
        return 'required'
      }
      return ''
    },
    allDateValidation() {
      if (
        this.reportForm.entDateFrom === undefined &&
        this.reportForm.entDateTo === undefined &&
        this.reportForm.tranDateFrom === undefined &&
        this.reportForm.tranDateTo === undefined &&
        this.reportForm.commDateFrom === undefined &&
        this.reportForm.commDateTo === undefined
      ) {
        this.fromDateValidation(this.reportForm.entDateFrom, this.reportForm.entDateTo)
        this.toDateValidation(this.reportForm.entDateFrom, this.reportForm.entDateTo)
        this.fromDateValidation(this.reportForm.tranDateFrom, this.reportForm.tranDateTo)
        this.toDateValidation(this.reportForm.tranDateFrom, this.reportForm.tranDateTo)
        this.fromDateValidation(this.reportForm.commDateFrom, this.reportForm.commDateTo)
        this.toDateValidation(this.reportForm.commDateFrom, this.reportForm.commDateTo)
        this.$toast.error('Must enter either Entry Date Range and/or Transaction Date Range and/or Commencement Date Range')
      } else {
        this.processExport()
      }
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('valDateRangeFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var fromDate = args[0]
        if (fromDate) {
          return !isAfter(removeTime(value), removeTime(fromDate))
        }
      }
    })
    this.$validator.extend('valDateRangeTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var toDate = args[0]
        if (toDate) {
          return !isAfter(removeTime(toDate), removeTime(value))
        }
      }
    })
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    MultiBranchHelpList,
    MultiPolTypeHelpList,
    TranTypeHelpListNew,
    AgencyHelpList,
    UserHelpList
  }
}
</script>
